import { render, staticRenderFns } from "./ManagerCallForm.vue?vue&type=template&id=65ef1b99&scoped=true&"
import script from "./ManagerCallForm.vue?vue&type=script&lang=js&"
export * from "./ManagerCallForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ef1b99",
  null
  
)

export default component.exports